export interface Environment {
    production: boolean;
    apiUrl: string;
}

export function buildEnvironment(properties: Partial<Environment>): Environment {
    return {
        production: properties.production ?? false,
        apiUrl: properties.apiUrl ?? '',
    };
}
